import React from "react";

const ButtonLoader = () => {
  return (
    <div className="flex items-center justify-center">
      <svg
        className="w-5 h-5 animate-spin text-gray-600 loader"
        viewBox="0 0 50 50"
      >
        <circle
          className="stroke-current"
          style={{ stroke: "white" }}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="4"
          strokeLinecap="round"
          color="white"
        ></circle>
      </svg>
    </div>
  );
};

export default ButtonLoader;
